import React, { Component, Fragment } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, Select, message, Input, Button } from 'antd';
import { CloseOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import Recharge from '../../recharge/Recharge';
import HTTP from '../../../script/service';
import Util from '../../../script/util';
import CodePay from '../../codePay/CodePay';
import Scrollbar from 'react-scrollbars-custom';
import WEBROOM from '../../../store/WebRoom';
import {
  _dssp_send_click,
  _new_nim_window,
  _change_phone_modal,
  _get_user_info,
  _change_order_modal,
  _change_ds_modal,
  _anly_seng_custom,
} from '../../../store/Action';
import './Order.scss';
import store from '../../../store/store';
import ShModal from '../../shModal/shModal';
import { PopoverEight, PopoverGiveFull } from '../dsUserSkillInfo/DiscountsTip';
import qs from 'qs';

class Order extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      payType: 0, // 支付方式 0=余额  5=微信  7=支付宝
      dsInfo: null, //大神资料
      full: false, //是否满足满2送1
      ehot: false, //是否是8元专区订单
      isEhot: 1, // 是否可以正常下8元单或者下单
      coupon: undefined, //使用优惠券
      coupons: [], //可使用优惠券
      selectCat: undefined, //选中的游戏品类
      num: 1,
      params: {},
      cdk_visible: false,
      remark: '', // 备注信息
      isHasBusy: false, // 是否有进行中的订单
      countDown: 180,
    };
  }
  //验证是否更新
  shouldComponentUpdate(newProps, newState) {
    if (newProps.base.dsOrder && !this.props.base.dsOrder) {
      this.showModal(newProps.base.dsOrder);
    }
    return true;
  }
  showModal = (param) => {
    const { uid, token, userInfo, rootConfig } = this.props.base;
    if (uid && token) {
      if (param.ehot) {
        this.get_god_category_detailed(param);
      } else {
        this.get_god_detailed(param);
      }
      if (param.money && rootConfig.lang == 'zh_CN') {
        let initMoney = parseFloat(param.money).toFixed(2);
        if (
          initMoney * 100 > userInfo.diamondAmount &&
          this.state.payType == 0
        ) {
          this.setState({
            payType: 5,
          });
        }
      }
    }
  };
  //8元订单的大神资料
  get_god_category_detailed = (param) => {
    const { uid } = this.props.base;
    HTTP._get_eight_god_category_detailed({
      uid: param.uid,
      categoryId: param.categoryId,
    }).then((res) => {
      if (res.code == 200) {
        const { modalZIndex } = this.props.base;
        // 层级永远高于聊天弹窗
        store.dispatch({
          type: 'change_modal_z_index',
          data: {
            modalZIndex: {
              ...modalZIndex,
              orderModal: modalZIndex.chatModal + 1,
            },
          },
        });
        this.setState(
          {
            visible: true,
            full: false,
            ehot: true,
            coupon: undefined,
            coupons: [],
            dsInfo: res.data,
            selectCat: undefined,
            num: param.num || 1,
            params: { ...param },
          },
          () => {
            this.setSelCat(param.categoryId);
          }
        );
      }
    });

    // 查询用户是否可以下折扣单
    if (param.ehot) {
      HTTP._get_order_has_discount({ uid, discountType: 0 }).then((res) => {
        if (res?.code === 200) {
          this.setState({ isEhot: parseInt(res.data) });
        }
      });
    }
  };
  //普通订单的大神资料
  get_god_detailed = (param) => {
    HTTP._get_god_category_detail({
      uid: param.uid,
      categoryId: param.categoryId,
    }).then((res) => {
      if (res.code == 200) {
        const { modalZIndex } = this.props.base;
        // 层级永远高于聊天弹窗
        store.dispatch({
          type: 'change_modal_z_index',
          data: {
            modalZIndex: {
              ...modalZIndex,
              orderModal: modalZIndex.chatModal + 1,
            },
          },
        });
        this.setState(
          {
            visible: true,
            full: res.data.fullGiveStutas == 0 ? false : true,
            ehot: false,
            coupon: undefined,
            coupons: [],
            dsInfo: res.data,
            selectCat: undefined,
            num: param.num || 1,
            params: { ...param },
          },
          () => {
            this.setSelCat(param.categoryId);
          }
        );

        this.get_god_has_busy(param);
      }
    });
    this.setState({ isEhot: 1 });
  };
  // 获取大神该资质是否有进行中的订单
  get_god_has_busy = (param) => {
    HTTP._get_god_has_busy({
      categoryId: param.categoryId,
      godUid: param.uid,
    }).then((res) => {
      if (res.code === 200) {
        this.setState({ isHasBusy: !!res.data });
      }
    });
  };
  //选择技能
  setSelCat = (categoryId) => {
    const { dsInfo } = this.state;
    let newcat = dsInfo.godCategoryList.filter(
      (item) => item.categoryId == categoryId
    );
    if (newcat && newcat.length > 0) {
      this.setState(
        {
          selectCat: {
            ...newcat[0],
            key: newcat[0].categoryId,
            label: newcat[0].categoryName,
          },
        },
        () => {
          this.clearMyCoupon();
        }
      );
    } else {
      message.warning('大神改资质已下架，暂不支持接单');
      this.hideModal();
    }
  };
  //获取我的优惠券
  clearMyCoupon = () => {
    this.setState({
      coupon: undefined,
      coupons: [],
    });
  };
  //计算价格
  conMoney = () => {
    const { selectCat, full, coupon, num, params } = this.state;
    if (!selectCat) {
      return 0;
    }
    let money = Number.parseFloat(selectCat.price * num).toFixed(2);
    //满足买2减1
    if (full && !params.hasGivefull && num > 2) {
      money = Number.parseFloat(selectCat.price * (num - 1)).toFixed(2);
    }
    //使用优惠券
    if (coupon) {
      //减免金额
      if (coupon.discountType == 1) {
        money = Number.parseFloat(money - coupon.discountSub);
      }
      //减免订单
      if (coupon.discountType == 2) {
        money = Number.parseFloat(
          selectCat.price * (num - coupon.discountSub)
        ).toFixed(2);
      }
      //折扣
      if (coupon.discountType == 3) {
        money = Number.parseFloat(money * coupon.discountSub * 0.1).toFixed(2);
      }
    }
    //这个是不合法的
    if (money < 0) {
      money = 0.0;
    }
    return money;
  };
  //改变技能
  categoryChange = (option) => {
    if (this.state.ehot) {
      this.get_god_category_detailed({
        ...this.state.params,
        ehot: true,
        num: this.state.num,
        categoryId: option.key,
      });
    } else {
      this.get_god_detailed({
        ...this.state.params,
        ehot: false,
        num: this.state.num,
        categoryId: option.key,
      });
    }
  };
  //改变数量
  changeNum = (n) => {
    const { num, ehot } = this.state;
    if (ehot) {
      message.info('8元订单只允许购买一次');
      return false;
    }
    let count = parseInt(num) + n;
    if (count < 1) {
      count = 1;
    } else if (count > 100) {
      count = 100;
    }
    this.setState({ num: count }, () => {
      this.clearMyCoupon();
    });
  };
  //触发获取优惠券
  targetEvent = (event) => {
    //如果已经选择优惠券
    if (this.state.coupon) {
      this.setState({
        cdk_visible: true,
      });
      return;
    }
    let orderType = 1;
    if (this.state.ehot) {
      orderType = 2;
    } else if (
      this.state.full &&
      !this.state.params.hasGivefull &&
      this.state.num > 2
    ) {
      orderType = 3;
    }
    HTTP._get_order_coupons({
      uid: this.props.base.uid,
      num: this.state.num,
      price: this.conMoney(),
      configId: this.state.selectCat.categoryId,
      orderType: orderType,
    }).then((res) => {
      if (res.code == 200) {
        this.setState({
          cdk_visible: true,
          coupons: res.data,
        });
      } else {
        message.warning(res.message);
      }
    });

    event.stopPropagation && event.stopPropagation();
    event.preventDefault && event.preventDefault();
  };
  // 备注信息
  onChangeRemark = (e) => {
    const value = e.target.value;
    this.setState({ remark: value });
  };
  //设置支付方式
  changePayType = (n) => {
    this.setState({ payType: n });
  };
  //确认大神接单状态
  confirmGodState = () => {
    // 判断用户是否选择最后一个
    // 判断用户钻石数量是否足够支付
    const { userInfo } = this.props.base;
    const { payType } = this.state;
    let orderMoney = this.conMoney();
    let payMoney = parseFloat(orderMoney * 100);
    if (payType == 0 && payMoney > userInfo.diamondAmount) {
      const diff = payMoney - userInfo.diamondAmount;
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: (
          <Fragment>
            <p>
              您的陪玩订单需要支付 <b>{payMoney.toFixed(0)}</b> 钻石
            </p>
            <span className="warn">钻石余额不足，还差 {diff} 钻石</span>
          </Fragment>
        ),
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '去充值',
        centered: true,
        onOk: () => {
          const needMoney = Math.ceil(
            (parseFloat(this.conMoney()) * 100 - userInfo.diamondAmount) / 100
          ); // 需要的钱
          this.RechargeElement.showModal(4, needMoney);
        },
      });
    } else {
      const { dsInfo } = this.state;
      const { uid } = this.props.base;
      HTTP._god_order_doing({
        uid: uid,
        toUid: dsInfo.uid,
      }).then((res) => {
        if (res.code == 200 && res.data) {
          Modal.confirm({
            title: '提示',
            icon: null,
            closable: true,
            content: <span>大神正在服务中， 确认继续下单?</span>,
            className: 'daidai-confirm-style',
            cancelText: '取消',
            okText: '确定',
            centered: true,
            onOk: () => {
              this.confirmOrder();
            },
          });
        } else {
          this.confirmOrder();
        }
      });
    }
  };
  //确认支付
  confirmOrder = () => {
    let OrderPrice = this.conMoney();
    let money = OrderPrice * 100;
    let { payType } = this.state;
    const { userInfo, rootConfig } = this.props.base;

    if (userInfo.diamondAmount < money && payType == 0) {
      if (rootConfig.lang == 'zh_CN') {
        payType = 5;
      } else {
        Modal.confirm({
          title: '提示',
          icon: null,
          closable: true,
          content: <span>您的钱包钻石余额不足，请先充值钻石</span>,
          className: 'daidai-confirm-style',
          cancelText: '取消',
          okText: '立即充值',
          centered: true,
          onOk: () => {
            this.RechargeElement.showModal(4, this.conMoney());
          },
        });
        return;
      }
    }
    if (payType == 0 || money <= 0) {
      Modal.confirm({
        title: '提示',
        icon: null,
        closable: true,
        content: (
          <span>
            您的陪玩订单需要支付<b>{money.toFixed(0)}</b>钻石
            <br />
            确认支付?
          </span>
        ),
        className: 'daidai-confirm-style',
        cancelText: '取消',
        okText: '确定',
        centered: true,
        onOk: () => {
          this.addOrder();
        },
      });
    }
    //直接充值
    else if (payType == 5 || payType == 7) {
      this.payForNormal(payType);
    } else if (payType == 23 || payType == 24) {
      this.RechargeElement.showModal(4, this.conMoney());
    } else if (payType === 41) {
      if (window.localStorage.getItem('isShTips')) {
        this.toShPay();
      } else {
        this.shElement.showTipModal();
      }
    }
  };

  toShPay = () => {
    const { payType } = this.state;
    let OrderPrice = this.conMoney();
    const params = {
      // uid,
      payFee: OrderPrice,
      diamond: OrderPrice * 100,
      payType,
      action: 4,
      origin: 1, // 来源，判断跳转地址  1:PC 2:H5 3:公众号
      configType: 1,
      merchantCode: 'shwk001',
    };
    HTTP._create_order_sh(params).then((res) => {
      if (res?.code === 200) {
        this.shElement.hideTipModal();
        window.open(res.data.url);
        let timer = setInterval(() => {
          this.setState({ countDown: this.state.countDown - 2 }, () => {
            if (this.state.countDown > 0) {
              HTTP._is_play_back({
                orderId: res.data.orderId,
                uid: this.props.base.uid,
              }).then((res2) => {
                if (res2?.code === 200 && res2.data) {
                  this.successCallback({
                    orderId: res.data.orderId,
                    price: OrderPrice,
                    payType,
                  });
                  clearInterval(timer);
                  this.setState({
                    countDown: 180,
                  });
                }
              });
            } else {
              clearInterval(timer);
              this.setState({
                countDown: 180,
              });
            }
          });
        }, 2000);
      } else {
        message.error(res?.message);
        this.shElement.hideTipModal();
      }
    });
  };

  payForNormal = (payType) => {
    const { rootConfig, uid, clientInfo, channelId } = this.props.base;
    const { selectCat, num, dsInfo } = this.state;
    let OrderPrice = this.conMoney();

    const params = {
      uid: uid,
      payFee: OrderPrice,
      diamond: OrderPrice * 100,
      payType: payType,
      action: 4,
      origin: 1,
      tgid: clientInfo.tgid || '',
      orderDetail: encodeURIComponent(
        JSON.stringify({
          categoryId: selectCat.categoryId,
          categoryName: selectCat.categoryName,
          num: num,
          unit: selectCat.unit,
          godUid: dsInfo.uid,
        })
      ),
    };
    HTTP._recharge_v4_pay(params)
      .then((res) => {
        if (res?.code === 200) {
          const hOid = res.data;
          const h5Params = {
            uid,
            type: payType,
            amount: OrderPrice * 100,
            price: OrderPrice,
            hOid,
            channelId,
            origin: 1,
            tgid: clientInfo.tgid || '',
          };
          const gid = Util.getReportParams('gid');
          const mac = Util.getReportParams('mac');
          const pcname = Util.getReportParams('pcname');
          const bootid = Util.getReportParams('bootid');
          if (gid) h5Params.gid = gid;
          if (mac) h5Params.mac = mac;
          if (pcname) h5Params.pcname = pcname;
          if (bootid) h5Params.bootid = bootid;
          const url = `${rootConfig.mobilePath}/h5charge?${qs.stringify(h5Params)}`;
          this.payElement.show({
            url,
            uid,
            payType,
            orderId: hOid,
            categoryId: selectCat.categoryId,
            action: 4,
            price: OrderPrice,
          });
        } else {
          message.error(res?.message || '操作失败，请稍后重试哦~');
          _anly_seng_custom('recharge_error', { data: { params, err: res } });
        }
      })
      .catch((err) => {
        _anly_seng_custom('recharge_error', {
          data: { params, err: err.toString() },
        });
        message.error('操作失败，请稍后重试哦~');
      });

    /*HTTP._recharge_v3_pay({
      uid: uid,
      payFee: OrderPrice,
      payType: payType,
      action: 4,
      origin: 1,
      tgid: clientInfo.tgid || "",
      orderDetail: JSON.stringify({
        categoryId: selectCat.categoryId,
        categoryName: selectCat.categoryName,
        num: num,
        unit: selectCat.unit,
        godUid: dsInfo.uid,
      }),
    }).then((res) => {
      if (res?.code === 200) {
        const url = `${rootConfig.mobilePath}/h5charge?uid=${uid}&type=${payType}&amount=${OrderPrice * 100}&price=${OrderPrice}&origin=1`;
        this.payElement.show({
          ...res.data,
          url,
          orderId: res.data.orderId,
          categoryId: selectCat.categoryId,
          action: 4,
          price: OrderPrice,
          payType: payType,
          uid: uid,
        });
      } else {
        message.error(res?.message || "操作失败，请稍后重试哦~");
      }
    });*/
  };
  //提交订单
  addOrder = () => {
    const { num, dsInfo, ehot, full, coupon, selectCat, params, remark } =
      this.state;
    const { dsModal } = this.props.base;
    let remarkText = remark;
    if (remarkText)
      remarkText = remark.replace(
        /<|iframe|alert|javascript|marquee|console|confirm/g,
        '*'
      );
    if (ehot) {
      HTTP._v2_add_eight({
        uid: this.props.base.uid,
        godUid: dsInfo.uid,
        orderRoomId: WEBROOM.getNowConRoom(),
        categoryId: selectCat.categoryId,
        couponId: coupon && coupon.id ? coupon.id : null,
        remark,
      }).then((res) => {
        if (res?.code === 200) {
          _dssp_send_click(35, {
            orderid: res.data,
            num: 1,
            price: selectCat.price,
            coupon: '',
            money: 0,
            diamond: this.conMoney() * 100,
            godUid: dsInfo.uid,
            categoryId: selectCat.categoryId,
            remark,
          });
          if (!!dsModal) {
            _change_ds_modal({
              dsid: dsInfo.uid,
              jnid: selectCat.categoryId,
              ehot: false,
            });
          }
          _get_user_info({ qKey: 'Order1' }, () => {
            this.hideModal();
            this.openNimChat();
          });
        }
        //绑定手机
        else if (res?.code === 3) {
          _change_phone_modal(true);
        }
        //余额不足
        else if (res?.code === 2) {
          message.warning(res.message);
          this.RechargeElement.showModal(4, this.conMoney());
        } else {
          message.warning(res?.message || '操作失败，请稍后重试哦~');
        }
      });
    } else if (full && !params.hasGivefull && num > 2) {
      HTTP._add_plus_times({
        uid: this.props.base.uid,
        godUid: dsInfo.uid,
        orderRoomId: WEBROOM.getNowConRoom(),
        categoryId: selectCat.categoryId,
        num: num,
        remark: remarkText,
      }).then((res) => {
        if (res?.code === 200) {
          _dssp_send_click(35, {
            orderid: res.data,
            num,
            price: selectCat.price,
            coupon: '',
            money: 0,
            diamond: this.conMoney() * 100,
            godUid: dsInfo.uid,
            categoryId: selectCat.categoryId,
            remark,
          });
          if (!!dsModal) {
            _change_ds_modal(null);
          }
          _get_user_info({ qKey: 'Order2' }, () => {
            this.hideModal();
            this.openNimChat();
          });
        }
        //绑定手机
        else if (res?.code === 3) {
          _change_phone_modal(true);
        }
        //余额不足
        else if (res?.code === 2) {
          message.warning(res.message);
          this.RechargeElement.showModal(4, this.conMoney());
        } else {
          message.warning(res?.message || '操作失败，请稍后重试哦~');
        }
      });
    } else {
      HTTP._v2_add_order({
        uid: this.props.base.uid,
        godUid: dsInfo.uid,
        orderRoomId: WEBROOM.getNowConRoom(),
        categoryId: selectCat.categoryId,
        num: num,
        couponId: coupon && coupon.id ? coupon.id : null,
        remark: remarkText,
      }).then((res) => {
        if (res?.code === 200) {
          _dssp_send_click(35, {
            orderid: res.data,
            num: num,
            price: selectCat.price,
            coupon: coupon && coupon.id ? coupon.id : null,
            money: 0,
            diamond: this.conMoney() * 100,
            godUid: dsInfo.uid,
            categoryId: selectCat.categoryId,
            remark,
          });
          _get_user_info({ qKey: 'Order3' }, () => {
            this.hideModal();
            this.openNimChat();
          });
        }
        //绑定手机
        else if (res?.code === 3) {
          _change_phone_modal(true);
        }
        //余额不足
        else if (res?.code === 2) {
          message.warning(res.message);
          this.RechargeElement.showModal(4, this.conMoney());
        } else {
          message.warning(res?.message || '操作失败，请稍后重试哦~');
        }
      });
    }
  };
  //选择优惠券
  setCoupon = (item) => {
    if (item) {
      if (item.useStatus != 0) {
        return;
      }
      this.setState({
        coupon: { ...item, key: item.id, label: item.name },
        cdk_visible: false,
      });
    } else {
      this.setState({
        coupon: undefined,
        cdk_visible: false,
      });
    }
  };
  //付款成功
  successCallback = (data) => {
    _dssp_send_click(66, {
      orderId: data.orderId,
      pay_fee: data.price,
      diamond_amount: data.price * 100,
      pay_type: data.payType,
    });
    _get_user_info(
      {
        qKey: 'Order4',
      },
      () => {
        //重新发起余额支付
        this.addOrder();
      }
    );
  };
  //聊一聊
  openNimChat = () => {
    let account = Util.$analyToAccount(this.state.dsInfo.uid);
    let to = {
      id: `p2p-${account}`,
      scene: 'p2p',
      account: account,
    };
    //标注
    _new_nim_window(to);
  };
  hideCDKModal = () => {
    this.setState({
      cdk_visible: false,
    });
  };
  hideModal = () => {
    _change_order_modal();
    this.setState({
      visible: false,
      remark: '',
      payType: 0,
    });
  };
  backTomain = () => {
    if (this.props.base.dsModal == null && this.props.base.dsOrder) {
      _change_ds_modal({
        dsid: this.props.base.dsOrder.uid,
        jnid: null,
        ehot: false,
      });
    }
    this.hideModal();
  };
  diamondPrice = (price) => {
    if (this.props.base.rootConfig.lang == 'zh_CN') {
      return (
        <div className="d-price">
          （{parseInt(price * 100)}
          <span className="d-icon"></span>）
        </div>
      );
    } else {
      return (
        <div style={{ lineHeight: '25px' }} className="d-price">
          {parseInt(price * 100)}
          <span className="d-icon"></span>
        </div>
      );
    }
  };
  // 8 元无法下单，点击仍要下单
  continueOrder = () => {
    const { params } = this.state;
    this.hideModal();
    _change_ds_modal({
      dsid: params.uid,
      jnid: params.categoryId,
      ehot: false,
    });
  };

  render() {
    const {
      dsInfo,
      payType,
      selectCat,
      num,
      full,
      coupon,
      coupons,
      params,
      remark,
      isHasBusy,
      isEhot,
    } = this.state;
    const { userInfo, rootConfig, isChannelSHWB } = this.props.base;
    const orderMoney = this.conMoney();
    let allOrderMoney = 0;
    if (selectCat) {
      allOrderMoney = Number.parseFloat(selectCat.price * num).toFixed(2);
    }

    return (
      <>
        <Modal
          open={this.state.visible}
          wrapClassName="iframe-body"
          centered={true}
          closable={false}
          footer={null}
          keyboard={false}
          maskClosable={false}
          zIndex={1001}
          width="1250px"
          height="720px"
        >
          <div className="pay-order-content noSelect">
            <div className="order-header">
              <span className="window-action-inpage" onClick={this.hideModal}>
                <CloseOutlined />
              </span>
            </div>
            {userInfo && dsInfo ? (
              <div className="order-content">
                <div className="order-submit-head">
                  <h2>确认订单信息</h2>
                  {!!isHasBusy && (
                    <div
                      className="order-submit-desc"
                      onClick={this.props.openNimChat}
                    >
                      <i className="order-ing order" />
                      Ta正在服务其它订单，下单前请与Ta沟通服务时间
                      <i className="order-ing goto" />
                    </div>
                  )}
                </div>
                <table>
                  <tbody>
                    <tr>
                      <th width="300">陪玩大神</th>
                      <th width="250">服务品类</th>
                      <th width="170">单价</th>
                      <th width="170">订单总价</th>
                      <th>购买数量</th>
                    </tr>
                    <tr>
                      <td>
                        <div className="cover">
                          <img
                            alt=""
                            src={Util.transImgUrl(dsInfo.headPic, '50x50')}
                          />
                        </div>
                        <div className="name">{dsInfo.nickName}</div>
                      </td>
                      <td>
                        <Select
                          value={selectCat}
                          labelInValue
                          onChange={this.categoryChange}
                          style={{ width: 210 }}
                        >
                          {dsInfo.godCategoryList &&
                            dsInfo.godCategoryList.map((item, index) => {
                              return (
                                <Select.Option
                                  value={item.categoryId}
                                  key={index}
                                >
                                  {item.categoryName}
                                </Select.Option>
                              );
                            })}
                        </Select>
                      </td>
                      {rootConfig.lang == 'zh_CN' && (
                        <td>
                          {selectCat ? (
                            <div className="txt">
                              <label>￥{selectCat.price}</label> /{' '}
                              {selectCat.unit}
                            </div>
                          ) : (
                            <span />
                          )}
                        </td>
                      )}
                      {rootConfig.lang != 'zh_CN' && (
                        <td>
                          {selectCat ? (
                            <div className="txt">
                              {this.diamondPrice(selectCat.price)}
                              <span> / {selectCat.unit}</span>
                            </div>
                          ) : (
                            <span />
                          )}
                        </td>
                      )}
                      {rootConfig.lang != 'zh_CN' && (
                        <td>
                          {selectCat ? (
                            <div className="price">
                              {this.diamondPrice(allOrderMoney)}
                            </div>
                          ) : (
                            <span />
                          )}
                        </td>
                      )}
                      {rootConfig.lang == 'zh_CN' && (
                        <td>
                          {selectCat ? (
                            <div className="price">
                              <p style={{ margin: 0 }}>￥{allOrderMoney}</p>
                              {this.diamondPrice(allOrderMoney)}
                            </div>
                          ) : (
                            <span />
                          )}
                        </td>
                      )}
                      <td>
                        {/* 买2送1 */}
                        {full && !params.hasGivefull ? (
                          <PopoverGiveFull />
                        ) : null}
                        {/* 8元专区 */}
                        {!!params.ehot ? <PopoverEight /> : null}
                        <span className="number-box">
                          <span
                            className="num-del"
                            onClick={this.changeNum.bind(this, -1)}
                          >
                            <MinusOutlined />
                          </span>
                          <span className="num-tt">{num}</span>
                          <span
                            className="num-add"
                            onClick={this.changeNum.bind(this, 1)}
                          >
                            <PlusOutlined />
                          </span>
                        </span>
                      </td>
                    </tr>
                    {!!isEhot && (
                      <tr>
                        <td colSpan="5" style={{ padding: 0 }}>
                          <div className="order-info">
                            <div className="row">
                              <label className="row-label">优惠券：</label>
                              <div
                                className="coupons"
                                onClick={this.targetEvent}
                              >
                                <Select
                                  placeholder="选择优惠券"
                                  labelInValue
                                  value={coupon}
                                  style={{ width: 250 }}
                                >
                                  {coupons &&
                                    coupons.map((item, index) => {
                                      return (
                                        <Select.Option
                                          key={`occ-${index}`}
                                          value={item.id}
                                        >
                                          {item.name}
                                        </Select.Option>
                                      );
                                    })}
                                </Select>
                                <span className="coupons-sel">
                                  {rootConfig.lang == 'zh_CN' ? (
                                    <Fragment>
                                      <div className="discount">
                                        -￥
                                        {Number.parseFloat(
                                          allOrderMoney - orderMoney
                                        ).toFixed(2)}
                                      </div>
                                      <div className="dis-d-price">
                                        {this.diamondPrice(
                                          allOrderMoney - orderMoney
                                        )}
                                      </div>
                                    </Fragment>
                                  ) : (
                                    <div className="discount">
                                      -{' '}
                                      {this.diamondPrice(
                                        Number.parseFloat(
                                          allOrderMoney - orderMoney
                                        ).toFixed(2)
                                      )}
                                    </div>
                                  )}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <label className="row-label">备注：</label>
                              <div className="coupons">
                                <Input
                                  style={{
                                    width: 300,
                                    height: 40,
                                    lineHeight: '40px',
                                  }}
                                  autoComplete="off"
                                  maxLength={50}
                                  placeholder="给大神备注 最多50个字"
                                  onChange={this.onChangeRemark}
                                  value={remark}
                                />
                              </div>
                            </div>
                            <div className="row">
                              <label
                                className="row-label"
                                style={{ lineHeight: '50px' }}
                              >
                                支付方式：
                              </label>
                              <div className="pay-type">
                                {isChannelSHWB &&
                                  rootConfig.lang == 'zh_CN' && (
                                    <span
                                      className={`sh-pay ${payType == 41 ? 'active' : ''}`}
                                      onClick={this.changePayType.bind(
                                        this,
                                        41
                                      )}
                                    >
                                      {/* 微信 */}
                                    </span>
                                  )}
                                {!isChannelSHWB &&
                                  rootConfig.lang == 'zh_CN' && (
                                    <span
                                      className={`weixin-pay ${payType == 5 ? 'active' : ''}`}
                                      onClick={this.changePayType.bind(this, 5)}
                                    >
                                      微信
                                    </span>
                                  )}
                                {!isChannelSHWB &&
                                  rootConfig.lang == 'zh_CN' && (
                                    <span
                                      className={`zhifubao-pay ${payType == 7 ? 'active' : ''}`}
                                      onClick={this.changePayType.bind(this, 7)}
                                    >
                                      支付宝
                                    </span>
                                  )}
                                <span
                                  className={`diamond-pay ${payType == 0 ? 'active' : ''}`}
                                  onClick={this.changePayType.bind(this, 0)}
                                >
                                  <p className="p1">钱包钻石余额</p>
                                  {rootConfig.lang == 'zh_CN' && (
                                    <p className="p2">
                                      ({userInfo.diamondAmount}钻 ={' '}
                                      {userInfo.diamondAmount / 100}元)
                                    </p>
                                  )}
                                  {rootConfig.lang != 'zh_CN' &&
                                    this.diamondPrice(
                                      userInfo.diamondAmount * 0.01
                                    )}
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <label className="row-label">实付款：</label>
                              {rootConfig.lang == 'zh_CN' && (
                                <div className="price">￥{orderMoney}</div>
                              )}
                              {rootConfig.lang == 'zh_CN' && (
                                <div className="dis-d-price">
                                  {this.diamondPrice(orderMoney)}
                                </div>
                              )}
                              {rootConfig.lang != 'zh_CN' && (
                                <div className="price">
                                  {this.diamondPrice(orderMoney)}
                                </div>
                              )}
                              <span className="cancel-back">
                                取消订单或订单过期，将退还钻石至您的钱包余额
                              </span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                {/* 不可下 8 元单 */}
                {!isEhot && (
                  <div className="not-ehot-content">
                    <p className="not-ehot-text">今日优惠已用完 请明日再来</p>
                    <Button
                      className="daidai-btn-primary"
                      onClick={this.continueOrder}
                    >
                      仍要下单
                    </Button>
                  </div>
                )}
                {!!isEhot && (
                  <div className="order-actions">
                    <button className="daidai-btn" onClick={this.backTomain}>
                      返回大神主页
                    </button>
                    {rootConfig.lang != 'zh_CN' && (
                      <button
                        className="daidai-btn-primary"
                        onClick={this.confirmGodState}
                      >
                        确认支付{this.diamondPrice(orderMoney)}
                      </button>
                    )}
                    {rootConfig.lang == 'zh_CN' && (
                      <button
                        className="daidai-btn-primary"
                        onClick={this.confirmGodState}
                      >
                        确认支付
                      </button>
                    )}
                  </div>
                )}
              </div>
            ) : null}
            {/* 我的优惠券 */}
            <Modal
              open={this.state.cdk_visible}
              wrapClassName="daidai-modal-style has-top-border"
              centered={true}
              title="我的优惠券"
              footer={null}
              keyboard={false}
              maskClosable={false}
              width="440px"
              zIndex="1010"
              onCancel={this.hideCDKModal}
            >
              <div className="my-cdk-coupon-list">
                <Scrollbar className="my-scroll-bar">
                  <div className="iscroll-html">
                    <div className="use-coupon">
                      <div className="cou-left">
                        <p className="p1">不使用优惠券</p>
                      </div>
                      <div className="cou-right">
                        <span
                          className={coupon ? 'radio-box' : 'radio-box active'}
                          onClick={this.setCoupon.bind(this, undefined)}
                        ></span>
                      </div>
                    </div>
                    {!coupons || coupons.length == 0 ? (
                      <div className="not-coupons-data">
                        <p>您暂时还没有可使用的优惠券哦~</p>
                      </div>
                    ) : null}
                    {coupons &&
                      coupons.map((item, index) => {
                        return (
                          <div
                            className={
                              item.useStatus == 0
                                ? 'use-coupon'
                                : 'use-coupon gray'
                            }
                            key={`coupon-${index}`}
                          >
                            <div className="cou-left">
                              <div className="cl">
                                {/* 减免金额 */}
                                {item.discountType == 1 ? (
                                  <div className="cl-1">
                                    {rootConfig.lang != 'zh_CN' && (
                                      <div
                                        style={{ lineHeight: '25px' }}
                                        className="d-price"
                                      >
                                        {item.discountSub * 100}
                                        <span className="d-icon"></span>
                                      </div>
                                    )}
                                    {rootConfig.lang == 'zh_CN' && (
                                      <span>
                                        ￥<b>{item.discountSub}</b>
                                      </span>
                                    )}
                                  </div>
                                ) : null}
                                {/* 减免订单 */}
                                {item.discountType == 2 ? (
                                  <div className="cl-1">
                                    <b>{item.discountSub}</b>单
                                  </div>
                                ) : null}
                                {/* 折扣 */}
                                {item.discountType == 3 ? (
                                  <div className="cl-1">
                                    <b>{item.discountSub}</b>折
                                  </div>
                                ) : null}

                                {item.couponType == 1 ? (
                                  <div className="cl-2">任意金额可用</div>
                                ) : (
                                  <div>
                                    {item.couponType == 2 &&
                                    item.discountType == 2 ? (
                                      <div className="cl-2">
                                        满{item.discountLimit}单可用
                                      </div>
                                    ) : (
                                      <div className="cl-2">
                                        满
                                        {rootConfig.lang == 'zh_CN'
                                          ? item.discountLimit + '元'
                                          : item.discountLimit * 100 + '钻'}
                                        可用
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              <div className="cr">
                                <div className="cr-1">{item.name}</div>
                                <div className="cr-2">
                                  <label
                                    className={`coupon-type type-${item.couponType}`}
                                  ></label>
                                  <span>{item.discountGoodName}</span>
                                </div>
                                {item.validEtime ? (
                                  <div className="cr-3">
                                    到期时间：
                                    {Util.dateFormat(
                                      item.validEtime,
                                      'YYYY-MM-DD HH:mm:ss'
                                    )}
                                  </div>
                                ) : (
                                  <div className="cr-3">到期时间：无限制</div>
                                )}
                              </div>
                            </div>
                            <div className="cou-right">
                              <span
                                className={
                                  coupon && coupon.id == item.id
                                    ? 'radio-box active'
                                    : 'radio-box'
                                }
                                onClick={this.setCoupon.bind(this, item)}
                              ></span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </Scrollbar>
              </div>
            </Modal>
            {/* 支付二维码 */}
            <CodePay
              ref={(el) => (this.payElement = el)}
              base={this.props.base}
              successCallback={this.successCallback}
            />
            {/* 充值模块 */}
            <Recharge
              wrappedComponentRef={(el) => (this.RechargeElement = el)}
              base={this.props.base}
            />
          </div>
        </Modal>
        <ShModal
          ref={(el) => (this.shElement = el)}
          toShPay={this.toShPay}
        />
      </>
    );
  }
}

export default withRouter(Order, { withRef: true });
